import Vue from 'vue';
import gaService from './ga.service';

export default {
  async openSession(gameId, language, isMobile) {
    gaService.send('games', 'smartsoft', gameId);
    return (await Vue.http.post('/api/smartsoft/session/open', { gameId, language, isMobile })).data;
  },
  async openDemoSession(gameId, language, isMobile) {
    gaService.send('games-demo', 'smartsoft', gameId);
    return (await Vue.http.post('/api/smartsoft/session/opendemo', { gameId, language, isMobile })).data;
  },
  async closeSession() {
    return (await Vue.http.post('/api/smartsoft/session/close')).data;
  }
}



// WEBPACK FOOTER //
// ./_common/services/smartsoft.service.js